<template>
  <div class="table_wrapper">
    <el-row :gutter="20">
      <el-col :span="24" class="table_welcome">
        <div class="mb-3" id="history_table">
          <el-table :data="displayData" @sort-change="sortChange">
            <el-table-column prop="dateTime" sortable :label="$t('promotion.tradingRewards.rewardDate')">
              <template slot-scope="scope">{{ formatDate(scope.row.dateTime) }}</template>
            </el-table-column>
            <el-table-column prop="amount" sortable :label="$t('promotion.tradingRewards.rewardAmount')">
              <template slot-scope="scope">
                <el-button
                  v-if="isUsingTotalProfit"
                  type="primary"
                  @click="openDialog(scope.row)"
                  data-testid="amount-key"
                  >{{ scope.row.amount }}</el-button
                >
                <span v-else>{{ scope.row.amount }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="mt4Account"
              sortable
              :label="$t('promotion.tradingRewards.accountNumber')"
              min-width="120"
            >
              <template slot-scope="scope"> {{ scope.row.mt4Account }} </template>
            </el-table-column>

            <template slot="empty">{{ $t('promotion.tradingRewards.noRewardHistory') }}</template>
          </el-table>
        </div>
        <el-pagination
          :page-size="10"
          layout="total, sizes, prev, pager, next"
          :total="totalData"
          :current-page.sync="pageNo"
          :page-sizes="[10, 25, 50, 100]"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          data-testid="pagination"
        ></el-pagination>
      </el-col>
    </el-row>
    <RewardLogsDialog :dialogVisible.sync="dialogVisible" :logDetails="logDetails" @closeDialog="closeDialog" />
  </div>
</template>

<script>
import RewardLogsDialog from './RewardLogsDialog.vue';
import moment from 'moment';
import { tradingRewardsEnum } from '@/constants/promotion';
import { apiRewardHistory, apiRewardHistoryLogs } from '@/resource';

export default {
  name: 'RewardHistory',
  props: { tradingMetric: String },
  components: { RewardLogsDialog },
  data() {
    return {
      displayData: [],
      pageSize: 10,
      pageNo: 1,
      totalData: 0,
      showData: null,
      dialogVisible: false,
      logDetails: null,
      sorting: {
        column: 'datetime',
        order: 'desc'
      }
    };
  },
  computed: {
    isUsingTotalProfit() {
      return this.tradingMetric == tradingRewardsEnum.PROFITORDER;
    },
    campaignId() {
      return this.$route.params.campaignId || null;
    }
  },
  mounted() {
    this.getHistoryList();
  },
  methods: {
    formatDate(dateTime) {
      return dateTime != null ? moment(dateTime).format('YYYY-MM-DD HH:mm:ss') : '-';
    },

    async openDialog(item) {
      if (this.campaignId) {
        await apiRewardHistoryLogs({
          rewardId: item.tradeRewardId,
          campaignId: this.campaignId
        })
          .then(res => {
            if (res.data.code === 0 && res.data.data) {
              this.logDetails = res.data.data;
              this.dialogVisible = true;
            }
          })
          .catch(error => {
            this.$message({
              message: this.$t('common.field.failed'),
              type: 'error',
              duration: 5000
            });
          });
      }
    },
    closeDialog() {
      this.logDetails = null;
      this.dialogVisible = false;
    },
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo;
      this.getHistoryList();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.getHistoryList();
    },
    sortChange(column, prop, order) {
      if (!column.column) {
        return;
      }
      this.sorting = { column: column.column.property, order: column.order };
      this.getHistoryList();
    },
    async getHistoryList() {
      if (this.campaignId) {
        const currentFilter = {
          pageNumber: this.pageNo - 1,
          pageSize: this.pageSize,
          campaignId: this.campaignId,
          sortBy: this.sorting.column,
          direction: this.sorting.order == 'ascending' ? 'asc' : 'desc'
        };
        await apiRewardHistory(currentFilter)
          .then(res => {
            if (res.data.code === 0 && res.data.data) {
              this.displayData = res.data.data.list;
              this.totalData = res.data.data.total;
            }
          })
          .catch(error => {
            this.$message({
              message: this.$t('common.field.failed'),
              type: 'error',
              duration: 5000
            });
          });
      }
    }
  },
  watch: {
    campaignId() {
      this.getHistoryList();
    }
  }
};
</script>
